var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "eye") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 18.116c0 0-0 0-0 0-7.132 0-12.914 5.782-12.914 12.914s5.782 12.914 12.914 12.914c7.132 0 12.914-5.782 12.914-12.914v0c-0.008-7.129-5.785-12.905-12.913-12.914h-0.001zM32 39.943c0 0-0 0-0 0-4.923 0-8.914-3.991-8.914-8.914s3.991-8.914 8.914-8.914c4.923 0 8.914 3.991 8.914 8.914v0c-0.006 4.921-3.993 8.908-8.913 8.914h-0.001z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.653 16.388l-0.027-0.028c-9.719-9.719-25.532-9.719-35.251 0l-12.374 12.864v3.612l12.374 12.864c4.511 4.511 10.742 7.301 17.625 7.301s13.115-2.79 17.625-7.301v0l12.374-12.864v-3.612zM58 31.224l-11.217 11.661c-3.785 3.779-9.012 6.116-14.783 6.116s-10.998-2.337-14.784-6.116l0 0-11.217-11.661v-0.388l11.216-11.66c8.156-8.141 21.412-8.141 29.568 0l11.216 11.66z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 29h4v4h-4v-4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.9020712f77ca62d8fc211df351c94e2c.svg";
export { ForwardRef as ReactComponent };